
import { ReactNode } from 'react';

interface BenefitCardProps {
  title: string;
  description: string;
  icon: ReactNode;
}

export const BenefitCard = ({ title, description, icon }: BenefitCardProps) => {
  return (
    <div className="bg-white rounded-xl p-6 shadow-soft hover-lift">
      <div className="w-14 h-14 rounded-full bg-dental-highlight/10 flex items-center justify-center mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-serif font-medium mb-3">{title}</h3>
      <p className="text-dental-muted">{description}</p>
    </div>
  );
};
